import { AfterResponseMiddleware } from '../types';

/**
 * Parse the response's `body` depending on the `content-type` header.
 */
export const responseBody: AfterResponseMiddleware = async (res) => {
  try {
    const mimeType = res.headers.get('content-type') || '';
    if (mimeType.startsWith('application/json')) {
      res.body = await res.response.json();
    } else if (mimeType.startsWith('text/')) {
      res.body = await res.response.text();
    }
  } catch (err) {
    // Silent error
  }
  return res;
};
